import { Dictionary } from "lodash";
import { LinkTO } from "./LinkTO";

export class PatchUserAccountTO {
    nome: string;
    sobrenome: string;
    headline: string;
    apresentacao: string;
    links: LinkTO[];
    customFields?: Dictionary<string>;
}
